export default __webpack_public_path__ + "static/media/package-icon.e361876e.svg";